module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_02@1.c4fe0931.png";